import React, {useContext, useEffect, useState} from "react";
import {AppContext} from "../../../contexts/AppContext";
import {
    DELIVERY_JOB_CREATION_FAILED,
    SELF_MANAGED_DELIVERY_PARTNER
} from "../../../helpers/Constants";
import {
    getAvailableDeliveryPartners,
    getSelectedDeliveryPartnerId
} from "../../../helpers/DeliveryPartnerHelper";
import {Box, makeStyles} from "@material-ui/core";
import Assets from "../../../helpers/assets";
import Colors from "../../../helpers/Colors";

function WarningMessage({order, type}) {
    const classes = useStyles();
    const {setIsCanceledHistoryDialogOpen, setSelectedOrder, available3plPartners} = useContext(AppContext)
    const [showWarning, setShowWarning] = useState(false)

    useEffect(() => {
        if (order.deliveryDetails.deliveryHistory && order.deliveryDetails.deliveryHistory.length > 0) {
            const errorList = order.deliveryDetails.deliveryHistory[0].deliveryHistoryInfoList.filter(history =>
                history.deliveryEventType === DELIVERY_JOB_CREATION_FAILED)
            if (errorList.length > 0) {
                setShowWarning(true)
            } else if (order.deliveryDetails.deliveryHistory.length > 1) {
                setShowWarning(true)
            }
        }
    }, [order.deliveryDetails])

    const onSeeMoreClick = () => {
        setIsCanceledHistoryDialogOpen(true)
        setSelectedOrder(order)
    }

    const warningMessage = () => {
        if (order.deliveryDetails.deliveryHistory && order.deliveryDetails.deliveryHistory.length > 0) {

            const deliveryHistory = order.deliveryDetails.deliveryHistory
            if (deliveryHistory.length > 2 ||
                (deliveryHistory.length === 2 && getSelectedDeliveryPartnerId(order,available3plPartners) === SELF_MANAGED_DELIVERY_PARTNER) ||
                order.deliveryDetails.noOf3plRequests !== deliveryHistory.length) {
                return <>Multiple requests have been made to partners. Please see the details and cancel requests manually.
                    &nbsp;<button className={classes.link} onClick={onSeeMoreClick}>[Show Details]</button></>
            }

            if (deliveryHistory.length > 1) {
                const firstElementHasErrors = deliveryHistory[0].deliveryHistoryInfoList.some(history => history.errorMessage && history.errorMessage.length > 0)
                const secondElementHasErrors = deliveryHistory[1].deliveryHistoryInfoList.some(history => history.errorMessage && history.errorMessage.length > 0)

                if (firstElementHasErrors || secondElementHasErrors) {
                    return <>Selected partner has been changed
                        from {available3plPartners.get(deliveryHistory[0].deliveryPartnerId)} to another one.
                        Please cancel it from their dashboard manually. &nbsp;<button className={classes.link} onClick={onSeeMoreClick}>[Show Details]</button></>
                } else {
                    return <>Selected partner has been changed
                        from {available3plPartners.get(deliveryHistory[0].deliveryPartnerId)} to another one.
                        Please cancel it from their dashboard manually.</>
                }
            }

            const errorList = deliveryHistory[0].deliveryHistoryInfoList.filter(history =>
                history.deliveryEventType === DELIVERY_JOB_CREATION_FAILED)
            if (errorList.length > 0) {
                const company = available3plPartners.get(deliveryHistory[0].deliveryPartnerId)
                if (type === 'completed') {
                    return <>Delivery job creation failed to {company}</>
                } else {
                    const availablePartnersForOrder = getAvailableDeliveryPartners(order.deliveryPartnerSelection);

                    if (availablePartnersForOrder.length > 1) {
                        return <>Delivery job creation failed to {company}. Please select another delivery partner.</>
                    } else if (availablePartnersForOrder.length === 1) {
                        return <>Delivery job creation failed to {company}</>
                    }
                }
            }
        }
    }

    return showWarning && <Box className={classes.deliveryWarning}>
        <img src={Assets.redCross.default} alt='' width={16}/>
        <Box style={{margin: '10px 0'}}>
            {warningMessage()}
        </Box>
    </Box>
}

const useStyles = makeStyles((theme) => ({
    deliveryWarning: {
        display: 'flex',
        alignItems: 'center',
        color: Colors.red,
        fontSize: 14,
        fontFamily: 'DINNextLTPro-Regular'
    },
    link: {
        textDecoration: 'underline',
        fontWeight: 'bold',
        cursor: 'pointer'
    }
}));

export default WarningMessage